import layout from '@/components/common/layout';
import flagList from '../views/flag/list';
import flagMy from '../views/flag/list-my';

export default [
    {
        path: '/flag',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "标签列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '11',// 父选项
                        child: 'flag_list',// 子选项
                    }
                },
                component: flagList,
            },
            {
                path: 'list-my',
                meta: {
                    metaInfo: {
                        title: "我的标签",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '11',// 父选项
                        child: 'flag_my',// 子选项
                    }
                },
                component: flagMy,
            },
        ]
    },
];
